// extracted by mini-css-extract-plugin
export default {"wrapper":"input_wrapper__wC5yv","toggle":"input_toggle__umNDd","password":"input_password__QTbYK","inputBox":"input_inputBox__tisJI","error":"input_error__1jbzk"};